// extracted by mini-css-extract-plugin
export default {"colors":"\"./../../constants/index.css\"","color_main":"#ffb74d","color_grey":"#d8d8d8","xxIcon":"Form_xxIcon__4bl3j"};